import * as React from "react"
import { graphql } from 'gatsby'

import Layout from "../components/layout/layout.component";
import Seo from "../components/seo"
import HeroSection from "../sections/index/hero-section/hero-section.component"
import Description from "../sections/index/description-section/description-section.component"
import Instructions from "../sections/index/instructions-section/instructions-section.component"
import ProjectSelection from "../sections/index/project-selection-section/project-selection.section"
import Prizes from "../sections/index/prizes-section/prizes-section.component"

const IndexPage = () =>{
    return (
        <Layout>
            <Seo lang="el"/>
            <HeroSection/>
            {/* <Description/> */}
            <Instructions/>
            <ProjectSelection/>
            <Prizes/>
        </Layout>
    )
}

export default IndexPage
